import { RequestState } from '../reducers/utils/state-manager';

export type AdminState = {
  twilioRegistrationSummary: TwilioRegistrationSummary;
  twilioRegistrationSummaryStatus: RequestState;
};

type State = { admin: AdminState };

export const twilioRegistrationSummarySelector = (state: State) =>
  state.admin.twilioRegistrationSummary;
export const twilioRegistrationSummaryStatusSelector = (state: State) =>
  state.admin.twilioRegistrationSummaryStatus;
